<template>
    <v-container fluid class="pa-4">
        <v-tabs v-model="tab" background-color="transparent" slider-color="primary" class="mb-2">
            <v-tab>Corsi</v-tab>
            <v-tab>Iscrizioni</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <!-- Corsi -->
            <v-tab-item>
                <v-card>
                    <v-card-title class="text-h6">
                        <v-icon left color="primary">mdi-school</v-icon>
                        Catalogo Formazione
                        <v-spacer></v-spacer>
                        <v-btn color="primary" small @click="openNewTraining">
                            <v-icon left small>mdi-plus</v-icon>Nuovo corso
                        </v-btn>
                    </v-card-title>
                    <v-data-table :headers="trainingHeaders" :items="trainings" :items-per-page="25">
                        <template v-slot:item.mandatory="{ item }">
                            <v-icon v-if="item.mandatory" color="error" small>mdi-check</v-icon>
                            <v-icon v-else color="grey" small>mdi-close</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn icon small @click="openEditTraining(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-tab-item>

            <!-- Iscrizioni -->
            <v-tab-item>
                <v-card>
                    <v-card-title class="text-h6">
                        <v-icon left color="primary">mdi-certificate</v-icon>
                        Iscrizioni dipendenti
                        <v-spacer></v-spacer>
                        <v-btn color="primary" small @click="openEnroll">
                            <v-icon left small>mdi-plus</v-icon>Nuova iscrizione
                        </v-btn>
                    </v-card-title>
                    <v-data-table :headers="enrollmentHeaders" :items="enrollments" :items-per-page="25">
                        <template v-slot:item.start_date="{ item }">{{ formatDate(item.start_date) }}</template>
                        <template v-slot:item.end_date="{ item }">{{ formatDate(item.end_date) }}</template>
                        <template v-slot:item.expires_at="{ item }">{{ formatDate(item.expires_at) }}</template>
                        <template v-slot:item.mandatory="{ item }">
                            <v-icon v-if="item.mandatory" color="error" small>mdi-check</v-icon>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-chip small :color="statusColor(item.status)" text-color="white">{{ statusText(item.status) }}</v-chip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-tab-item>
        </v-tabs-items>

        <!-- Dialog corso -->
        <v-dialog v-model="trainingDialog" max-width="500">
            <v-card>
                <v-card-title><v-icon left color="primary">mdi-school-outline</v-icon>{{ trainingForm.id ? 'Modifica corso' : 'Nuovo corso' }}</v-card-title>
                <v-card-text>
                    <v-text-field v-model="trainingForm.name" label="Nome corso" prepend-icon="mdi-book" outlined dense></v-text-field>
                    <v-text-field v-model="trainingForm.provider" label="Provider" prepend-icon="mdi-domain" outlined dense></v-text-field>
                    <v-row dense>
                        <v-col cols="6"><v-text-field v-model.number="trainingForm.hours" type="number" label="Ore" prepend-icon="mdi-timer" outlined dense></v-text-field></v-col>
                        <v-col cols="6"><v-text-field v-model.number="trainingForm.validity_months" type="number" label="Validità (mesi)" prepend-icon="mdi-calendar-refresh" outlined dense></v-text-field></v-col>
                    </v-row>
                    <v-checkbox v-model="trainingForm.mandatory" label="Obbligatorio"></v-checkbox>
                    <v-textarea v-model="trainingForm.description" label="Descrizione" prepend-icon="mdi-text" outlined dense rows="2"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="trainingDialog = false">Annulla</v-btn>
                    <v-btn color="primary" @click="saveTraining">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog iscrizione -->
        <v-dialog v-model="enrollDialog" max-width="500">
            <v-card>
                <v-card-title><v-icon left color="primary">mdi-certificate</v-icon>Nuova iscrizione</v-card-title>
                <v-card-text>
                    <v-autocomplete v-model="enrollForm.employee_id" :items="employees" item-text="text" item-value="value" label="Dipendente" prepend-icon="mdi-account-tie" outlined dense></v-autocomplete>
                    <v-autocomplete v-model="enrollForm.training_id" :items="trainings.map(t=>({value:t.id,text:t.name}))" item-text="text" item-value="value" label="Corso" prepend-icon="mdi-school" outlined dense></v-autocomplete>
                    <v-row dense>
                        <v-col cols="6"><gmh-date-picker v-model="enrollForm.start_date" label="Inizio" prepend-icon="mdi-calendar-start" editable></gmh-date-picker></v-col>
                        <v-col cols="6"><gmh-date-picker v-model="enrollForm.end_date" label="Fine" prepend-icon="mdi-calendar-end" editable></gmh-date-picker></v-col>
                    </v-row>
                    <v-select v-model="enrollForm.status" :items="[{value:'planned',text:'Pianificato'},{value:'ongoing',text:'In corso'},{value:'completed',text:'Completato'},{value:'failed',text:'Non superato'}]" label="Stato" prepend-icon="mdi-list-status" outlined dense></v-select>
                    <gmh-date-picker v-model="enrollForm.expires_at" label="Scade il" prepend-icon="mdi-calendar-alert" editable></gmh-date-picker>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="enrollDialog = false">Annulla</v-btn>
                    <v-btn color="primary" @click="saveEnrollment">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    export default {
        name: 'hr-trainings',

        data() {
            return {
                tab: 0,
                trainings: [],
                enrollments: [],
                employees: [],
                trainingDialog: false,
                trainingForm: { name: '', provider: '', hours: 0, validity_months: 12, mandatory: false, description: '' },
                enrollDialog: false,
                enrollForm: { employee_id: null, training_id: null, start_date: '', end_date: '', status: 'planned', expires_at: '' },
                trainingHeaders: [
                    { text: 'Nome', value: 'name' },
                    { text: 'Provider', value: 'provider' },
                    { text: 'Ore', value: 'hours' },
                    { text: 'Obblig.', value: 'mandatory', align: 'center' },
                    { text: 'Validità', value: 'validity_months' },
                    { text: '', value: 'actions', sortable: false, align: 'end' },
                ],
                enrollmentHeaders: [
                    { text: 'Dipendente', value: 'employee_full_name' },
                    { text: 'Corso', value: 'training_name' },
                    { text: 'Inizio', value: 'start_date' },
                    { text: 'Fine', value: 'end_date' },
                    { text: 'Scadenza', value: 'expires_at' },
                    { text: 'Obbl.', value: 'mandatory', align: 'center' },
                    { text: 'Stato', value: 'status' },
                ],
            }
        },

        methods: {
            load() {
                this.axios.get('hrtrainings').then(r => { this.trainings = r.data.data || [] })
                this.axios.post('hrtrainings/enrollments-filters').then(r => { this.enrollments = r.data.data || [] })
                this.axios.post('hremployees-filters').then(r => {
                    const data = r.data.data && r.data.data.data ? r.data.data.data : (Array.isArray(r.data.data) ? r.data.data : [])
                    this.employees = data.map(e => ({ value: e.id, text: `${e.first_name || ''} ${e.last_name || ''}`.trim() || `#${e.id}` }))
                })
            },
            openNewTraining() { this.trainingForm = { name: '', provider: '', hours: 0, validity_months: 12, mandatory: false, description: '' }; this.trainingDialog = true },
            openEditTraining(t) { this.trainingForm = Object.assign({}, t); this.trainingDialog = true },
            saveTraining() {
                const url = this.trainingForm.id ? `hrtrainings/${this.trainingForm.id}` : 'hrtrainings'
                const method = this.trainingForm.id ? 'put' : 'post'
                this.axios[method](url, this.trainingForm).then(() => { this.trainingDialog = false; this.load() })
            },
            openEnroll() { this.enrollForm = { employee_id: null, training_id: null, start_date: '', end_date: '', status: 'planned', expires_at: '' }; this.enrollDialog = true },
            saveEnrollment() {
                this.axios.post('hrtrainings/enroll', this.enrollForm).then(() => { this.enrollDialog = false; this.load() })
            },
            statusText(s) { return { planned: 'Pianificato', ongoing: 'In corso', completed: 'Completato', failed: 'Non superato' }[s] || s },
            statusColor(s) { return { planned: 'grey', ongoing: 'orange', completed: 'green', failed: 'red' }[s] || 'grey' },
            formatDate(d) { return d ? new Date(d).toLocaleDateString('it-IT') : '—' },
        },

        created() {
            this.$store.commit('endProgress')
            this.load()
        },
    }
</script>
